"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var PlayerAuthLogList = /** @class */ (function (_super) {
    __extends(PlayerAuthLogList, _super);
    function PlayerAuthLogList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Игрок',
                key: "v-" + _this.props.dataLogs.dk_key,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.player.login));
                },
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.dataLogs.dk_brand_title,
                key: _this.props.dataLogs.dk_brand_title,
                width: 200,
            }, {
                title: 'IP адрес',
                dataIndex: _this.props.dataLogs.dk_ip_address,
                key: _this.props.dataLogs.dk_ip_address,
                width: 200,
            }, {
                title: 'Useragent',
                dataIndex: _this.props.dataLogs.dk_useragent,
                key: _this.props.dataLogs.dk_useragent,
                width: 200,
            }, {
                title: 'Отпечаток',
                dataIndex: _this.props.dataLogs.dk_fingerprint,
                key: _this.props.dataLogs.dk_fingerprint,
                width: 200,
            }, {
                title: 'Тип авторизации',
                dataIndex: _this.props.dataLogs.dk_auth_kind,
                key: _this.props.dataLogs.dk_auth_kind,
                width: 200,
            }, {
                title: 'Добавлено',
                dataIndex: _this.props.dataLogs.dk_date_added,
                key: _this.props.dataLogs.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 80
            }
        ];
        return _this;
    }
    PlayerAuthLogList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataLogs.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
    };
    PlayerAuthLogList.prototype.componentWillUnmount = function () {
        this.props.dataLogs.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PlayerAuthLogList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
                // nextProps.dataLogs.LoadData(this.props.player.key);
            });
        }
    };
    PlayerAuthLogList.prototype.loadData = function (Props, onDone) {
        Props.dataLogs.LoadRangeData({
            playerId: Props.player.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    PlayerAuthLogList.prototype.onDeleteClick = function (record) {
        var _this = this;
        this.props.dataLogs.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041B\u043E\u0433 \u0437\u0430 \u0434\u0430\u0442\u0443 ",
                React.createElement("b", null,
                    "[",
                    record.date_added.format(_this.props.state.getDateTimeFormat()),
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    PlayerAuthLogList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            /*this.props.dataLogs.LoadData(this.props.player.key, () => {
                if (this.props.onPageConfigChanged) {
                    this.props.onPageConfigChanged(_page, PageSize);
                }
            });*/
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerAuthLogList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            //this.props.dataLogs.LoadData(this.props.player.key);
            this.loadData(this.props);
        }
        if (action === "create") {
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerAuthLogList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    PlayerAuthLogList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0433\u0440\u043E\u043A:"),
                            " [",
                            _this.props.player.login,
                            "]")));
                } })));
    };
    return PlayerAuthLogList;
}(React.Component));
exports.default = PlayerAuthLogList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/auth_logs/PlayerAuthLogList.tsx
// module id = 1926
// module chunks = 0